import { useCallback, useEffect } from "react";
import { getTenantsMW } from "pages/PanelPage/middleware";

const cache = {};

const useFetchTenants = (setTenants, enabled = true) => {
  const fetchTenants = useCallback(async () => {
    if (cache?.data) {
      setTenants(cache.data);
      return;
    }

    const tenants = await getTenantsMW();
    setTenants(tenants);
    cache.data = tenants;
  }, []);

  useEffect(() => {
    if (enabled) fetchTenants();
  }, [fetchTenants, enabled]);
};

export default useFetchTenants;
